import { Layout, Menu } from 'antd';
import styled from 'styled-components';

const { Header } = Layout;

export const StyledContent = styled.div`
 margin-top: ${(props) => props.$marginval};
 flex-grow:2;
`;
export const StyledHeaderLayout = styled(Header)`
  position: fixed;
  z-index: 1;
  width: 100%;
`;

export const StyledMenu = styled(Menu)`
  line-height: 64px;
  white-space: normal;
  border-right: 0;
`;
